import { Grid, Typography } from '@atgfr8/atg-ui-tailwind';

interface StatusBadgeProps {
  text: string;
  color: string | ((text: string) => string);
  size: 'small' | 'medium';
}

export const StatusBadge = (props: StatusBadgeProps) => {
  const getColor = (text: string) => {
    if (typeof props.color === 'string') {
      return props.color;
    }
    return props.color(text);
  };

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      backgroundColor={getColor(props.text)}
      class={`py-[4px] ${
        props.size === 'medium' ? 'px-[8px]' : 'px-[4px]'
      } rounded-[4px]`}
    >
      <Typography variant="body1" class="text-white">
        {props.text}
      </Typography>
    </Grid>
  );
};
